import { useEffect, useState } from "react";
import { Singleton } from "../../../core/services/Singleton";
import { TalentService } from "../../../core/services/TalentService";
import { BasicTable, MASK_MYEDITOR, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { MyEditor } from "../../theme/Component/MyEditor";
import { QuestionItems } from "./QuestionItems";
import { SpanRender } from "../../theme/Component/SpanRender";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _ProofAccounts } from "../../../core/services/dataBean/EntityCatalog";

interface Props {
    idTest: number;
}

export const TestQuestion = ({ idTest }: Props) => {

    const services = new TalentService();
    const single = Singleton.getInstance();
    const [lista, setLista] = useState([]);
    const _proodAccount = useDataBean(_ProofAccounts);
    const [bean, setBean] = useState<any>({});
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalQuestion, setModalQuestion] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalConfirm, setModalConfirm] = useState<any>({ name: 'Confirmar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    

    useEffect(() => {
        if (idTest >= 0) {
            getLista()
        }
    }, [idTest])

    const idBean = 'IDTestQuestion';

    const head = [
        { title: 'ID', property: idBean,mask:MASK_NUMBER },
        { title: 'Orden', property: 'ItemOrden',mask:MASK_NUMBER },
        { title: 'Pregunta', property: 'Question' },
        { title: 'Tipo de Pregunta', property: 'TypeName' },
    ]

    const setRowBean = (bean: any) => {
        //console.log("Row : ", bean);
        setBean(bean);
    }

    const renderName = (value: number) => {
        let type = '';
        if (value === 1) {
            type = 'Respuesta Unica'
        } else if (value === 2) {
            type = 'Respuesta Multiple'
        } else if (value === 3) {
            type = 'Verdadero/Falso'
        }
         else if (value === 4) {
            type = 'Pregunta Abierta'
        }
        return type;
    }

    const getLista = () => {
        const x = {
            "IDTest": idTest,
            State: 1
        }
        single.spinner(true);
        _proodAccount.instance.getTestQuestionRender(1,1000,x).then(
            (resp: any) => {
                if (resp.List) {
                    let x = resp.List;
                    x.forEach((test: any) => {
                        test.DataBeanProperties.TypeName = renderName(test.DataBeanProperties.QuestionType)
                    });
                    setLista(x)
                }
                single.spinner(false)
            }
        )
    }

    const deleteItem = () => {
        bean.State = 2;
        updateItem();
        setModalConfirm({ ...modalConfirm, 'view': false });
    }

    const updateItem = () => {
        setModal({ ...modal, "view": false })
        single.spinner(true);
        services.updateTestQuestion(bean).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    getLista();
                }
                single.spinner(false)
                if (bean.IDTest) {
                    single.update(bean);
                } else {
                    single.create(bean)
                }
            }
        )
    }

    const agregarItem = () => {
        let b = {
            Question: "",
            QuestionType: undefined,
            IDTest: idTest,
            State: 1,
        }
        setBean(b);
        setModal({ ...modal, 'view': true });

    }

    const listaBotones = () => {
        const botones = [

            { titulo: 'Opciones de respuesta', icono: 'ri-task-line', visible: ([1,2].includes(bean.QuestionType)), evento: () => { setModalQuestion({ ...modalQuestion, "name": `Opciones de Respuesta`, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-file-list-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-file-user-line', visible: single.canDelete(), evento: () => { setModalConfirm({ ...modalConfirm, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: true, icono: 'ri-file-add-line', evento: agregarItem }
    ]

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <BasicTable body={lista} head={head} rowSet={setRowBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} />
                </div>
            </div>

            {modal.view &&
                <Modal modal={modal} updateModal={setModal} eventModal={updateItem}>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Orden</label>
                            <input type="number" name="orden" className="form-control" value={bean.ItemOrden} onChange={(e)=>{setBean({...bean,"ItemOrden":parseInt(e.target.value)})}} />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Tipo de Pregunta</label>
                            <select className='form-select' value={bean.QuestionType} onChange={(e) => { setBean({ ...bean, "QuestionType": e.target.value }) }}>
                                <option value={undefined}>...</option>
                                <option value={1}>Respueta Unica</option>
                                <option value={2}>Respuesta Multiple</option>
                                <option value={3}>Verdadero o Flaso </option>
                                <option value={4}>Pregunta Abierta </option>
                            </select>
                        </div>
                        <div className="col-md-4">
                            <BasicSwitch label="Requiere justificación" estado={bean.RequireAnswer} eventChange={(e)=>{setBean({...bean,"RequireAnswer":e})}}/>
                        </div>
                        <div className="col-md-12">
                            <label className="form-label">Pregunta</label>
                            <MyEditor allowImage={true} val={bean.Question} onChange={(e: any) => { setBean({ ...bean, "Question": e }) }} />
                        </div>
                    </div>
                </Modal>
            }
            {modalQuestion.view &&
                <Modal modal={modalQuestion} updateModal={setModalQuestion} >
                    <SpanRender value={bean.Question} mask={MASK_MYEDITOR}/>
                    <QuestionItems QuestionTest={bean} _idTest={idTest} />
                </Modal>
            }
            {modalConfirm.view &&
                <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={deleteItem}>
                    {bean.Name}
                </ModalConfirm>
            }
        </>
    )
}